<template>
  <div class="button-selector-wrapper">
    <label v-if="label">{{ label }}</label>
    <div class="field" :class="groupType">
      <p v-for="opcao in listaDeOpcoes" :key="opcao" class="control">
        <TrfButton
            :nome="opcao.label"
            :temIcon="false"
            :classCor=buttonStyle(opcao)
            :id="opcao?.id"
            @click.prevent="acionarOpcao(opcao);"
        />
      </p>
    </div>
  </div>
</template>

<script>

import TrfButton from '../Button';

export default {
  name: "TrfButtonSelector",
  expose: ['limparSelect', '_selecionarDefault', 'valor'],
  components: {
    TrfButton,
  },
  props: {
    label: {
      type: String,
      required: false
    },
    listaDeOpcoes: {
      type: [Array],
      required: true,
    },
    opcaoSelecionada: {
      type: [Object],
      required: false,
      default: null
    },
    podeDesmarcar: {
      type: [Boolean],
      required: false,
      default: true
    },
    isAddOn: {
      type: [Boolean],
      required: false,
      default: false
    },
    required: {
      type: [Boolean],
      required: false,
      default: false
    },
    validate: {
      type: [Function],
      required: false,
      default: function validacaoBasica() {
        if(!!this && !this.required) {
          return true;
        };

        if(!!this && !!!this.selectedOption) {
          return false;
        }
      }()
    },
    isValid: {
      type: [Boolean],
      required: false,
      default: !!this && this.validate()
    },
  },
  data() {
    return {
      valor: this.opcaoSelecionada
    };
  },
  computed: {
    groupType: function() {
      return this.isAddOn? 'has-addons' : 'is-grouped';
    },
    valorSelecionado: {
      get() {
        return this.valor
      },
      set(value) {
        this.valor = value || null;
      }
    }
  },
  methods: {
    validacaoBasica() {
      if(!this.required) {
        return true;
      };

      if(!!!this.selectedOption) {
        return false;
      }
    },
    buttonStyle: function(opcao) {
      const estiloPadrao = opcao.estiloPadrao || 'is-outlined';
      const estiloSelecionado = opcao.estiloSelecionado || 'is-primary';
      const isOpcaoSelecionada = this.valorSelecionado == opcao
      return isOpcaoSelecionada? estiloSelecionado : estiloPadrao;
    },
    acionarOpcao(opcao, isSelecionarDefault = false) {
      if(this.valorSelecionado == opcao && this.podeDesmarcar && !isSelecionarDefault) {
        this.valorSelecionado = null;
        this.desmarcarOpcao(this.valorSelecionado);
      } else {
        this.desmarcarOpcao(this.valorSelecionado);

        opcao.isSelected = true;
        this.valorSelecionado = opcao;
      }

      this.$emit('update:opcaoSelecionada', this.valorSelecionado);
    },
    desmarcarOpcao(opcao) {
      if(opcao != null) {
        opcao.isSelected = false;
      }
    },
    _selecionarDefault() {
      if(!!this.opcaoSelecionada) {
        this.acionarOpcao(this.opcaoSelecionada, true);
      }
      const opcaoSelecionada = this.listaDeOpcoes?.find(opcao => opcao.isSelected === true);
      if(!!opcaoSelecionada) {
        this.acionarOpcao(opcaoSelecionada, true);
      }
      this.$emit('update:opcaoSelecionada', this.valor);
    },
    limparSelect() {
      if (!this.valorSelecionado) return
      this.valorSelecionado = undefined
      this.$emit('update:opcaoSelecionada', this.valor);
    }
  },
  mounted() {
    this._selecionarDefault();
  }, 
};
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variables.scss";
$light-grey: #cccccc;
$dark-grey: #333333;
$orange: #f90;
$dark-orange: #f63;
.control > .button {
  min-width:115px;
}
#inputPagina {
  width: 55%;
  margin-right: -1px;
  border-radius: 4px 0 0 4px;
  border-color: lighten($dark-grey, 50%);
}
#buscarPorPagina {
  border-radius: 0 4px 4px 0;
  border-color: lighten($dark-grey, 50%);
}
#botaoAdicao {
  margin-left: 0.3rem;
  border-radius: 4px;
}
#botaoanterior {
  border-radius: 4px 0 0 4px;
  margin-right: -1px;
}
#botaoproximo {
  border-radius: 0 4px 4px 0;
  margin-left: -1px;
}
#botaoprimeiro,
#botaoultimo {
  border-radius: 15px;
  padding: 5px;
  width: auto;
  height: 32px;
}
.column {
  padding: 0;
}
.pagination {
  margin: 0 0 40px 0;
  display: flex;
  .item {
    padding: 0.5rem 0.75rem;
    border: 1px solid $light-grey;
    cursor: pointer;
    background-color: white;
    color: var(--tertiaryColor, $tertiary);
    height: 34px;
    font-size: 14px;
    line-height: 20px;
    text-align: center;

    &:first-child {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }
    &:last-child {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }

    &:hover {
      background-color: $light-grey;
      border-color: lighten($dark-grey, 50%);
      z-index: 3;
    }
    &.current {
      cursor: default;
      color: var(--secondaryColor, --white);
      background-color: $orange;
      border-color: $dark-orange;
      z-index: 2;
    }
    + .item {
      margin-left: -0.063rem;
      margin-right: 0;
    }
  }
  .desabilitado {
    font-size: 14px;
    padding: 0.5rem 0.75rem;
    border: 0.063rem solid $light-grey;
    background-color: white;
    color: #b3b1b3;
    height: 2.125rem;
    line-height: 20px;
  }
  .foco {
    background-color: var(--primaryColor, $primary);
    border-color: var(--primaryColorLight, $primary);
    color: var(--secondaryColor, --white);
    &:hover {
      background-color: none;
    }
  }
  .select {
    height: 2.1rem;
  }
  #selectLimit {
    border-color: #b3b3b3;
    margin: 0 0 0.625rem 0;
  }
}
</style>
